import React, { useEffect, useRef } from 'react';

import { useAuthentication, useBrowserNotification, useConfig } from '../hooks';
import { BrowserNotificationOptions } from '../types/browserNotificationOptions';

export const Activity = (): React.ReactElement => {
  const { auth } = useAuthentication();
  const { showBrowserNotification } = useBrowserNotification();
  const config = useConfig();
  const timeout = config.auth.activityTimeout * 1000 || 30 * 60 * 1000;
  const timeForNotification = timeout - 5 * 60 * 1000;

  const createNotificationTimeout = () => {
    return setTimeout(() => {
      const options: BrowserNotificationOptions = {
        title: 'Connected Vehicle Portal',
        body: `You will be logged off from the Connected Vehicle Portal session in 5 minutes due to inactivity. Click on this notification to stay logged in.`,
        icon: '/static/images/icon.png',
        renotify: true,
        requireInteraction: true,
        tag: 'logout-notification',
        navigateUrl: '/app/activecase',
        callback: () => auth.registerActivity(),
        audioPath: '/static/audio/browsernotification.mp3',
      };
      showBrowserNotification(options);
    }, timeForNotification);
  };
  const notificationTimeoutRef = useRef(createNotificationTimeout());

  useEffect(() => {
    const handleActivity = () => {
      auth.registerActivity();
      clearTimeout(notificationTimeoutRef.current);
      notificationTimeoutRef.current = createNotificationTimeout();
    };

    if (auth) {
      document.addEventListener('mousedown', handleActivity);
      document.addEventListener('keypress', handleActivity);
    }

    return () => {
      document.removeEventListener('mousedown', handleActivity);
      document.removeEventListener('keypress', handleActivity);
      clearTimeout(notificationTimeoutRef.current);
    };
  });
  return <></>;
};
